import { Stack } from '@backyard-ui/core'

import { SelectOption } from '../SelectOption'
import {
  TernarySelectorOptionsType,
  TernarySelectorType
} from '../../MarketPlace/types'

interface SelectTernaryOptionsGroupProps {
  options: TernarySelectorOptionsType
  selected: 'SIM' | 'NAO' | ''
  onClick: (option: TernarySelectorType) => void
}

const SelectTernaryOptionsGroup = (
  props: Readonly<SelectTernaryOptionsGroupProps>
) => {
  const { options, onClick, selected } = props

  return (
    <Stack direction="column" className="w-fit inline rounded-lg">
      {options.map((option, index) => (
        <SelectOption
          key={option.key}
          label={option.label}
          isSelected={option.key === selected}
          isDisabled={!!selected}
          onSelect={() => onClick(option)}
          isFirst={index === 0}
          isLast={index === options.length - 1}
        />
      ))}
    </Stack>
  )
}

export default SelectTernaryOptionsGroup
